import { render, staticRenderFns } from "./history-action-details.vue?vue&type=template&id=59731040&scoped=true"
import script from "./history-action-details.vue?vue&type=script&lang=js"
export * from "./history-action-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59731040",
  null
  
)

export default component.exports